import angular from 'angular'
import ngRedux from 'ng-redux'

import template from '../../../templates/customer/wr-customer-loyalty-balance.html'
import { LoyaltyManager } from '../../managers/loyalty-manager'
import { selectCurrentSaleAsSale } from '../../state/slices/currentSale/currentSaleSlice'

/**
 * Directive for displaying a customer's loyalty balance. If the provided customer matches the customer on the
 * current sale, the loyalty balance is adjusted as the sale is updated.
 *
 * @module webregister.directives.wrCustomerLoyaltyBalance
 */
angular
  .module('webregister.directives')
  .directive(
    'wrCustomerLoyaltyBalance',
    function (loyaltyManager: LoyaltyManager, $ngRedux: ngRedux.INgRedux) {
      return {
        scope: {
          customer: '=',
          customerBalances: '=',
        },
        restrict: 'E',
        template,
        bindToController: true,
        controllerAs: 'customerLoyaltyBalanceCtrl',

        /**
         * =======================================
         * CUSTOMER LOYALTY BALANCE CONTROLLER
         * =======================================
         */
        controller(this: $TSFixMe) {
          /**
           * Calculate the loyalty balance for the customer. If the sale is not completed, this is calculated as the
           * current loyalty balance minus the total loyalty payments for the sale (adjustedLoyaltyBalance). Otherwise
           * calculated as adjustedLoyaltyBalance plus the total loyalty earned for current sale.
           *
           * @method calculateCustomerLoyaltyBalance
           *
           * @return {Number} The customer loyalty balanace
           */
          this.calculateCustomerLoyaltyBalance = function () {
            const currentSale = selectCurrentSaleAsSale($ngRedux.getState())
            const currentSaleCustomer = currentSale && currentSale.customer
            const currentLoyaltyBalance =
              (this.customerBalances && this.customerBalances.loyalty) || 0

            if (
              !currentSaleCustomer ||
              currentSaleCustomer.id !== this.customer.id
            ) {
              return currentLoyaltyBalance
            }

            return loyaltyManager.getCustomerLoyaltyBalance(currentSale)
          }
        },
      }
    }
  )
